// Chakra Imports
import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  Flex,
  Link,
  Switch,
  Text,
  useColorMode,
  useColorModeValue,
  Input,
  useToast,
} from "@chakra-ui/react";

import { useRef } from "react";

import { HSeparator } from "components/Separator/Separator";
import React, { useState, useEffect } from "react";
import GitHubButton from "react-github-btn";
import { FaFacebook, FaInstagram, FaWhatsapp } from "react-icons/fa";

import gana from "../../img/gana.png";

export default function Configurator(props) {
  const {
    sidebarVariant,
    setSidebarVariant,
    secondary,
    isOpen,
    onClose,
    fixed,
    ...rest
  } = props;
  const [switched, setSwitched] = useState(props.isChecked);
  const [iduser, setIduser] = useState(0);

  const { colorMode, toggleColorMode } = useColorMode();

  let bgButton = useColorModeValue(
    "linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)",
    "white"
  );
  let colorButton = useColorModeValue("white", "gray.700");
  const secondaryButtonBg = useColorModeValue("white", "transparent");
  const secondaryButtonBorder = useColorModeValue("gray.700", "white");
  const secondaryButtonColor = useColorModeValue("gray.700", "white");
  const bgDrawer = useColorModeValue("white", "navy.800");
  const settingsRef = React.useRef();

  const inputRef = useRef(null);
  const toast = useToast();

  const copyLink = () => {
    if (inputRef.current) {
      inputRef.current.select();
      document.execCommand("copy");

      toast({
        title: "Enlace copiado",
        description: "El enlace ha sido copiado al portapapeles.",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    }
  };

  const copyLinkinstagram = () => {
    const link = "https://www.royalinsurancellc.com/#/i/" + iduser;

    navigator.clipboard
      .writeText(link)
      .then(() => {
        toast({
          title: "Enlace copiado",
          description: "El enlace ha sido copiado al portapapeles.",
          status: "success",
          duration: 2000,
          isClosable: true,
        });
      })
      .catch((err) => {
        console.error("Error al copiar: ", err);
        toast({
          title: "Error",
          description: "No se pudo copiar el enlace.",
          status: "error",
          duration: 2000,
          isClosable: true,
        });
      });
  };

  const obtenerid = () => {
    const data = {
      token: localStorage.getItem("token_royal"),
    };
    fetch(`${process.env.REACT_APP_API}/veridwill`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result) {
          if (result.message) {
            if (result.message == "Access Denied") {
              window.location.href = "/#/auth/signin";
              window.location.reload();
            } else {
              setIduser(result.message);
            }
          }
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    obtenerid();
  }, []);

  useEffect(() => {
    console.log("ESTE ES EL ID " + iduser);
  }, [iduser]);

  return (
    <>
      <Drawer
        isOpen={props.isOpen}
        onClose={props.onClose}
        placement={document.documentElement.dir === "rtl" ? "left" : "right"}
        finalFocusRef={settingsRef}
        blockScrollOnMount={false}
      >
        <DrawerContent bg={bgDrawer}>
          <DrawerHeader pt="24px" px="24px">
            <DrawerCloseButton />
            <Text
              fontSize="xl"
              fontWeight="bold"
              mt="16px"
              align="center"
              color="#003366" // Cambia este valor según el color que desees
            >
              COMPARTE TU ENLACE
            </Text>

            <HSeparator />
            <img src={gana} style={{ borderRadius: "10px" }} width="100%" />
            <HSeparator />
          </DrawerHeader>
          <DrawerBody w="340px" ps="24px" pe="40px">
            <Flex flexDirection="column">
              <Flex
                justifyContent="space-between"
                alignItems="center"
                mb="24px"
              >
                <Input
                  ref={inputRef}
                  value={`https://app.royalinsurancellc.com/#/d/${iduser}`}
                  isReadOnly
                  variant="filled"
                  size="md"
                  width="auto"
                  mr="12px"
                />
                <Button onClick={copyLink}>Copy</Button>
              </Flex>

              <HSeparator />
              <Box mt="24px">
                <Box w="100%">
                  <Text mb="6px" textAlign="center">
                    Share your link on:
                  </Text>
                  <Flex
                    justifyContent="center"
                    flexDirection="column"
                    alignItems="center"
                    width="60%"
                    mx="auto"
                    gap="12px"
                  >
                    <Link
                      isExternal
                      href={`https://api.whatsapp.com/send?text=%C2%A1Gana%20dinero%20invitando%20a%20tus%20amigos!%0AComparte%20esta%20oportunidad%3A%20si%20alguien%20contrata%20un%20seguro%20de%20salud%20gracias%20a%20tu%20recomendaci%C3%B3n%2C%20t%C3%BA%20recibes%20una%20recompensa%20%F0%9F%92%B8%0A%C2%A1Es%20f%C3%A1cil%2C%20r%C3%A1pido%20y%20t%C3%BA%20eliges%20a%20qui%C3%A9n%20invitar!%0AConoce%20m%C3%A1s%20y%20empieza%20hoy%20mismo%20%F0%9F%91%89%20https%3A%2F%2Fapp.royalinsurancellc.com%2F%23%2Fw%2F${iduser}`}
                      style={{ width: "100%" }}
                    >
                      <Button
                        width="100%"
                        colorScheme="whatsapp"
                        leftIcon={<FaWhatsapp />}
                      >
                        <Text>WhatsApp</Text>
                      </Button>
                    </Link>

                    <Link
                      isExternal
                      href={`https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fapp.royalinsurancellc.com%2F%23%2Ff%2F${iduser}`}
                      style={{ width: "100%" }}
                    >
                      <Button
                        width="100%"
                        colorScheme="facebook"
                        leftIcon={<FaFacebook />}
                      >
                        <Text>Facebook</Text>
                      </Button>
                    </Link>

                    <Link
                      isExternal
                      onClick={() => {
                        copyLinkinstagram();
                      }}
                      style={{ width: "100%" }}
                    >
                      <Button
                        width="100%"
                        colorScheme="pink"
                        leftIcon={<FaInstagram />}
                      >
                        <Text>Instagram</Text>
                      </Button>
                    </Link>
                  </Flex>
                </Box>
              </Box>
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
